export default __webpack_public_path__ + "static/media/fs-banner.f7d3dd70.png";